<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">
        สถานที่ตั้งบริษัท
      </span>
      <v-scroll-x-transition>
        <div style="display: flex" v-show="!locationFormShow">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            style="width: 200px; padding: 0 5px"
          ></v-text-field>
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::company_location:create')
            "
            style="margin-top: 1px"
            color="primary"
            @click="handleAddLocationForm"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่มสถานที่ตั้งบริษัท
          </v-btn>
        </div>
      </v-scroll-x-transition>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="locations"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.latitude="{ item }">
        {{
          item.latitude.split('.')[0] +
          item.latitude.substr(item.latitude.indexOf('.'), 6)
        }}
      </template>
      <template v-slot:item.longitude="{ item }">
        {{
          item.longitude.split('.')[0] +
          item.longitude.substr(item.longitude.indexOf('.'), 6)
        }}
      </template>
    </v-data-table>
    <LocationForm
      :formShow="locationFormShow"
      :formAction="locationFormAction"
      :location="location"
      :locationInit="locationInit"
      @isLocationDataChange="handleLocationFormDataChange"
      @formActionCompleted="handleLocationFormActionCompleted"
      @onReset="handleLocationFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="locationFormShow && locationFormAction === 'add'"
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import LocationForm from '@/views/location/LocationForm.vue'

export default {
  components: {
    LocationForm,
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      sortBy: ['title_th'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: true,
      search: '',
      headers: [
        {
          text: 'สถานที่ตั้งบริษัท',
          align: 'start',
          value: 'title_th',
        },
        { text: 'ละติจูด', value: 'latitude' },
        { text: 'ลองจิจูด', value: 'longitude' },
        { text: 'รัศมี (เมตร)', value: 'radius_meter' },
        { text: 'Timezone', value: 'timezone' },
      ],
      locationFormShow: false,
      locationFormAction: '',
      location: {},
      locationInit: {},
      isLocationDataChange: false,
      timeout: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    markersInit() {
      return this.$store.state.googleMap.markersInit
    },
    locations() {
      return this.$store.state.location.locations
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'สถานที่ตั้งบริษัท',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchLocations: 'location/fetchLocations',
    }),
    classRowSelected(row) {
      if (this.location.company_location_uuid === row.company_location_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::company_location:get')) {
        this.dialogForbidden = true
        return
      }

      if (this.location.company_location_uuid === row.company_location_uuid) {
        this.locationFormShow = false
        this.locationFormAction = ''
        this.location = {}
        this.locationInit = {}

        this.$store.commit('googleMap/SET_MARKERS', [])
        this.$store.commit('googleMap/SET_MARKERS_INIT', [])
      } else {
        this.locationFormShow = true
        this.locationFormAction = 'edit'
        this.location = { ...row }
        this.locationInit = { ...row }

        const markers = []
        const latLng = {
          lat: parseFloat(row.latitude),
          lng: parseFloat(row.longitude),
        }
        markers.push({ position: latLng })
        this.$store.commit('googleMap/SET_MAP_CENTER', latLng)
        this.$store.commit('googleMap/SET_MARKERS', markers)
        this.$store.commit('googleMap/SET_MARKERS_INIT', markers)
      }
    },
    handleRowSelected(row) {
      if (this.isLocationDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddLocationForm() {
      this.locationFormShow = true
      this.locationFormAction = 'add'
      this.location = { timezone: '+07:00' }
      this.locationInit = { timezone: '+07:00' }

      this.$store.commit('googleMap/SET_MARKERS', [])
      this.$store.commit('googleMap/SET_MARKERS_INIT', [])
    },
    handleLocationFormDataChange(value) {
      this.isLocationDataChange = value
    },
    handleLocationFormReset(formAction) {
      if (formAction === 'edit') {
        this.$store.commit(
          'googleMap/SET_MARKERS',
          JSON.parse(JSON.stringify(this.markersInit))
        )
        this.location = { ...this.locationInit }
      }
    },
    handleLocationFormActionCompleted(formAction) {
      this.location = {}
      this.locationInit = {}

      this.$store.commit('googleMap/SET_MARKERS', [])
      this.$store.commit('googleMap/SET_MARKERS_INIT', [])

      this.locationFormShow = false
      this.locationFormAction = ''
    },
    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      this.fetchLocations(company_uuid)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.$store.commit('googleMap/SET_MARKERS', [])
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.locationFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isLocationDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
